<script lang="ts">
  import type { Translate } from "../i18n";

  const {
    fps,
    criticalAt,
    t,
  }: { fps: number; criticalAt: number; t: Translate } = $props();

  // Two states only: a rate at or below the critical line is red, everything
  // above it green. The meter reads as a health light, not as a gradient.
  const critical = $derived(fps <= criticalAt);
</script>

<div
  class="panel fps"
  class:fps--critical={critical}
  aria-label={t("fps.title")}
  aria-live="off"
>
  <span class="fps__value">{Math.round(fps)}</span>
  <span class="fps__unit">{t("fps.unit")}</span>
</div>
